import styled from "@emotion/styled";
import LineItemGrid from "components/Common/LineItemGrid/LineItemGrid";
import { ModContainer } from "components/Common/LineItemGrid/LineItemGridStyles";
import { BuildNewOrderLineItemsHeader } from "components/NewOrders/NewOrders.styles";
import { skeletonClasses } from "@mui/material";

export const CustomQuoteDetailWrapper = styled.div<{ isLoading?: boolean }>(({ theme, isLoading }) => ({
	display: "flex",
	flexDirection: "column",
	padding: "16px",
	gap: "16px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	[`& > .${skeletonClasses.root}:first-of-type`]: {
		width: "50%",
		height: "42px"
	},
	[theme.breakpoints.down("md")]: {
		[`${BuildNewOrderLineItemsHeader} div:first-child`]: {
			marginBottom: 0,
			paddingBottom: 0
		}
	},
	...(isLoading && {
		"> div": {
			display: "flex",
			flexDirection: "column",
			gap: "16px",
			maxWidth: "239px"
		},
		gap: "24px",
		paddingBottom: "54px"
	})
}));

export const CustomQuoteTitle = styled.div(({ theme }) => ({
	...theme.project.typography.overline
}));

export const CustomQuoteAccountBillTo = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	gap: "16px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	},
	"> div": {
		display: "flex",
		flexDirection: "column",
		padding: "16px",
		width: "50%",
		border: theme.project.borders.presets.thinOutline,
		[theme.breakpoints.down("md")]: {
			width: "inherit"
		},
		"> div": {
			...theme.project.typography.subtitle.subtitle1,
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
			"> div": {
				...theme.project.typography.body.body2,
				textTransform: "none",
				display: "flex",
				flexDirection: "column"
			}
		},
		"> div:first-of-type": {
			...theme.project.typography.subtitle.subtitle1,
			marginBottom: "16px"
		}
	}
}));

export const CustomQuoteItemDetailTitle = styled.div(({ theme }) => ({
	fontSize: "16px",
	textTransform: "uppercase",
	color: theme.project.colors.fontColors.secondary
}));

// Mobile detail fields all need to be horizontal like "Label -- Value"

export const CustomQuoteItemDetailField = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	[theme.breakpoints.down("md")]: {
		flexDirection: "row"
	},
	"> div:nth-of-type(1)": {
		...theme.project.typography.subtitle.subtitle2
	},
	"> div:nth-of-type(2)": {
		...theme.project.typography.body.body2
	}
}));

export const CustomQuoteCustomizationDescription = styled.div(({ theme }) => ({
	"div:nth-of-type(odd)": {
		...theme.project.typography.subtitle.subtitle2
	},
	"div:nth-of-type(even)": {
		...theme.project.typography.body.body2
	}
}));

export const CustomQuoteLineItemGrid = styled(LineItemGrid)<{ isListPrice?: boolean }>(({ theme, isListPrice }) => ({
	"& > div:first-of-type > div:first-of-type": {
		gridColumn: isListPrice ? "span 4" : "span 6"
	},
	[`& > ${ModContainer}`]: {
		gridRow: "unset" // Default is grid-row: 2, which breaks for this view
	}
}));
